<template>
  <div>
    <div v-if="list.length > 0">
      <person-mission-list-web :list="list" class="hidden-sm-and-down" />
      <person-mission-list-mob :list="list" class="hidden-md-and-up" />
    </div>
    <div v-else>
      <EmptyList />
    </div>
  </div>
</template>

<script>
import PersonMissionListMob from "../periodDetails/PersonMissionList/PersonMissionListMob.vue";
import PersonMissionListWeb from "../periodDetails/PersonMissionList/PersonMissionListWeb.vue";

export default {
  components: { PersonMissionListWeb, PersonMissionListMob },

  props: {
    perno: String,
    date: String,
  },
  mounted() {
    this.getPersonMissionList();
  },
  data() {
    return {
      list: [],
    };
  },
  methods: {
    getPersonMissionList() {
      const params = new URLSearchParams();
      params.append("beginDate", this.date);
      params.append("endDate", this.date);
      params.append("searchKind", "status = 10");
      params.append("perno", this.perno);

      this.$store.dispatch("PersonMissionList", { params }).then((result) => {
        if (result.type === "success") {
          this.list = result.data;
        }
      });
    },
  },
};
</script>

<style>
</style>